import { space } from '../spacing.js';
import { colors } from '../colors.js';
export const container = {
    backgroundColor: colors.backgrounds.default,
};
export const content = {
    margin: space.x6,
};
//# sourceMappingURL=body.js.map